import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/swiper-bundle.css";
import "./FacilitiesPage.css";

const facilities = [
  {
    img: "/images/Facilities/3.webp",
    title: "Major Operation Theatre",
    desc: "Modern OT designed for precision and safety in complex surgeries.",
  },
  {
    img: "/images/Facilities/5.webp",
    title: "Minor Operation Theatre",
    desc: "Ideal for daycare & minimally invasive surgical procedures.",
  },
  {
    img: "/images/Facilities/4.webp",
    title: "ICU",
    desc: "Advanced monitoring & intensive care for critical patients.",
  },
  {
    img: "/images/Facilities/34.webp",
    title: "Private Rooms",
    desc: "Comfortable, peaceful rooms for smooth recovery.",
  },
  {
    img: "/images/Facilities/33.webp",
    title: "Emergency Care",
    desc: "24/7 emergency support for trauma & critical cases.",
  },
  {
    img: "/images/Facilities/pharmacy.webp",
    title: "In House Pharmacy Store",
    desc: "Safe, hygienic, and convenient pharmacy services.",
  },
];

const FacilitiesPage = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: false, mirror: true });

    // SEO Meta
    document.title = "Facilities | Dr. Chavan Multispeciality Hospital, Indapur";

    const metaDescription = document.createElement("meta");
    metaDescription.name = "description";
    metaDescription.content =
      "Explore Dr. Chavan Multispeciality Hospital's advanced medical facilities including OTs, ICU, emergency care, private rooms, and in-house pharmacy in Indapur.";
    document.head.appendChild(metaDescription);

    const metaKeywords = document.createElement("meta");
    metaKeywords.name = "keywords";
    metaKeywords.content =
      "Medical facilities Indapur, hospital OT ICU emergency, private rooms, pharmacy, Dr. Chavan Hospital";
    document.head.appendChild(metaKeywords);

    const canonical = document.createElement("link");
    canonical.rel = "canonical";
    canonical.href = "https://drchavanhospital.in/facilities";
    document.head.appendChild(canonical);

    // JSON-LD Structured Data
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "MedicalOrganization",
      "name": "Dr. Chavan Multispeciality Hospital",
      "url": "https://drchavanhospital.in/",
      "logo": "https://drchavanhospital.in/images/logo.webp",
      "image": "https://drchavanhospital.in/images/pageheader.jpg",
      "description": "Advanced multi-speciality hospital in Indapur with modern OTs, ICU, emergency care, and pharmacy.",
      "department": facilities.map((f) => ({
        "@type": "MedicalSpecialty",
        "name": f.title,
        "description": f.desc
      })),
      "sameAs": [
        "https://www.facebook.com/yourhospital",
        "https://www.instagram.com/yourhospital",
        "https://www.linkedin.com/company/yourhospital"
      ]
    });
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(metaDescription);
      document.head.removeChild(metaKeywords);
      document.head.removeChild(canonical);
      document.head.removeChild(script);
    };
  }, []);

  return (
    <section className="facilities">
      <div className="facilities-header" data-aos="fade-up" data-aos-delay="100">
        <h2>Our Specialized Departments</h2>
        <h1>Advanced Medical Facilities</h1>
        <p>
          Explore our modern, multi-speciality medical infrastructure designed to
          ensure high-quality and safe healthcare for every patient.
        </p>
      </div>

      {/* Desktop View */}
      <div className="facilities-grid desktop-view">
        {facilities.map((facility, index) => (
          <div
            key={index}
            className="facility-card"
            data-aos="fade-up"
            data-aos-delay={(index % 3) * 350}
          >
            <img src={facility.img} alt={facility.title} className="facility-img" />
            <h3>{facility.title}</h3>
            <p>{facility.desc}</p>
          </div>
        ))}
      </div>

      {/* Mobile View */}
      <div className="mobile-view">
        <Swiper
          spaceBetween={20}
          slidesPerView={1}
          loop={true}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          modules={[Autoplay]}
          className="facilities-swiper"
        >
          {facilities.map((facility, index) => (
            <SwiperSlide key={index}>
              <div className="facility-card">
                <img src={facility.img} alt={facility.title} className="facility-img" />
                <h3>{facility.title}</h3>
                <p>{facility.desc}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default FacilitiesPage;
